<div [attr.data-test]="'feature-homepage'">
  <div class="row">
    <div class="col-12">
      <app-content-banner [bannerKey]="homePageBannerKey"></app-content-banner>
      @if (isLoggedIn) {
        @if (((homeInstallBase$ | async) && (isBusinessPartnerRole$ | async) === false)) {
          <app-install-base>
          </app-install-base>
        }
        @if (isShopByCategoryActive && (isAnyTileAvailable$ | async)) {
          <app-shop-categories>
          </app-shop-categories>
        }
      }
      <app-featured-product [featuredProductsKey]="featuredProductsKey"></app-featured-product>
    </div>
  </div>
</div>
